import { useMainStore } from '../stores/useMainStore.js'

let clientInstance = null

/**
 * Erstellt einen fetch-basierten API-Client für Vigo
 */
function createFetchClient(baseURL, defaultHeaders = {}) {
  return {
    async get(url, config = {}) {
      const validateStatus = config.validateStatus || ((status) => status >= 200 && status < 300)
      
      const params = config.params || {}
      const queryString = new URLSearchParams(params).toString()
      const fullUrl = `${baseURL}${url}`
      const finalUrl = queryString ? `${fullUrl}?${queryString}` : fullUrl
      
      const response = await fetch(finalUrl, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          ...config.headers
        }
      })
      
      // Validiere den Status mit der validateStatus-Funktion
      if (!validateStatus(response.status)) {
        throw new Error(`HTTP Error: ${response.status}`)
      }
      
      const responseData = await response.json()
      return {
        status: response.status,
        statusText: response.statusText,
        data: responseData,
        headers: response.headers
      }
    },
    
    async post(url, data, config = {}) {
      const validateStatus = config.validateStatus || ((status) => status >= 200 && status < 300)
      
      const params = config.params || {}
      const queryString = new URLSearchParams(params).toString()
      const fullUrl = `${baseURL}${url}`
      const finalUrl = queryString ? `${fullUrl}?${queryString}` : fullUrl
      
      const response = await fetch(finalUrl, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          ...config.headers
        },
        body: JSON.stringify(data)
      })
      
      // Validiere den Status mit der validateStatus-Funktion
      if (!validateStatus(response.status)) {
        throw new Error(`HTTP Error: ${response.status}`)
      }
      
      const responseData = await response.json()
      return {
        status: response.status,
        statusText: response.statusText,
        data: responseData,
        headers: response.headers
      }
    }
  }
}

/**
 * Gibt den Vigo API-Client zurück (Lazy Initialization).
 * Der Client wird beim ersten Aufruf erstellt und nutzt die Konfiguration aus dem MainStore.
 * @returns {Object}
 */
export function getApiClientVigo() {
  if (!clientInstance) {
    const store = useMainStore()
    const baseURL = store.dataAttributes.apiVigotr || ''
    const apiKey = store.dataAttributes.apiKey || ''
    
    if (!baseURL) {
      console.warn('apiVigotr nicht in data-Attributen gefunden')
    }
    if (!apiKey) {
      console.warn('apiKey nicht in data-Attributen gefunden')
    }
    
    clientInstance = createFetchClient(baseURL, {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'ApiKey': apiKey
    })
  }
  return clientInstance
}

/**
 * Setzt den Client zurück (für Tests oder Widget-Reinitialisierung)
 */
export function resetApiClientVigo() {
  clientInstance = null
}
